import React, { Component } from 'react';

import EditFrequency from './EditFrequency.js';

class EditFrequencyContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {pattern:props.initialPattern};
        this.updatePattern = this.updatePattern.bind(this);
    }

    updatePattern(p) {
        this.setState({pattern:p});
    }

    render() {
        return <EditFrequency {...this.props}
                   updatePattern={this.updatePattern}
                   pattern={this.state.pattern} />;
    }
}

export default EditFrequencyContainer;



// WEBPACK FOOTER //
// ./src/modules/categories/EditFrequencyContainer.js